module.exports = __webpack_public_path__ + "static/media/Closeclose.ec7db628.svg";